import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-workflowconfig',
  templateUrl: './workflowconfig.component.html',
  styleUrls: ['./workflowconfig.component.scss']
})
export class WorkflowconfigComponent implements OnInit {

  constructor() { }

  ngOnInit() {
    if (!sessionStorage.getItem('reloaded')) {
      sessionStorage.setItem('reloaded', 'true');
      window.location.reload();
    
    }
  }

}



// WEBPACK FOOTER //
// /app/src/app/workflowconfig/workflowconfig.component.ts